import React, { useMemo } from "react";

import { ButtonToolbar, Dropdown, Loader } from "rsuite";
import {
    downloadNumbersCommon,
    downloadNumbersTxtCommon,
} from "utils";
import { MAX_RATE_DIALER, MIN_RATE_DIALER } from "const";

import { FormattedMessage, useIntl } from "react-intl";
import styled, { css } from "styled-components";
import m from "definedMessages";

export default (
    {
        service,
        currentDisplay,
        activeTrunkId,
        uploadLoading,
        setUploadingLoading,
        filter,
        formatMessage,
        ...props
    }
) => {

    const downloadFilter = useMemo(() => ({
        ...filter,
        rate_min: filter.rate_min || MIN_RATE_DIALER,
        rate_max: filter.rate_max || MAX_RATE_DIALER
    }), [filter]);

    const handleDownloadCompleteNumbersCsv = () => {
        downloadNumbersCommon(activeTrunkId, downloadFilter, () => setUploadingLoading(activeTrunkId, false), service)
    };

    const handleDownloadCompleteNumbersTxt = () => {
        downloadNumbersTxtCommon(activeTrunkId, downloadFilter, () => setUploadingLoading(activeTrunkId, false), service)
    };


    return (
        <StyledButtonToolbar>
            <StyledDropdown
                appearance="default"
                onSelect={() => setUploadingLoading(activeTrunkId, true)}
                title={<>{uploadLoading[activeTrunkId] ? <StyledLoader /> : formatMessage(m.download)}</>}
                disabled={currentDisplay !== "trunk_number" || !activeTrunkId || uploadLoading[activeTrunkId]}
                {...props}
            >

                <Dropdown.Item
                    onClick={handleDownloadCompleteNumbersCsv}
                >
                    <FormattedMessage
                        id="common.downloadAllocatedNumbersAs"
                        defaultMessage="Download allocated numbers as {type}"
                        values={{ type: "csv" }}
                    />
                </Dropdown.Item>

                <Dropdown.Item
                    onClick={handleDownloadCompleteNumbersTxt}
                >
                    <FormattedMessage
                        id="common.downloadAllocatedOnlyNumbersAs"
                        defaultMessage="Download only numbers"
                        values={{ type: "txt" }}
                    />
                </Dropdown.Item>

            </StyledDropdown>
        </StyledButtonToolbar>
    )
};


const StyledButtonToolbar = styled(ButtonToolbar)`
    width: 140px;
    display: inline-block; 
    margin-right: 10px;
    ${props =>
        props.width && css`
            width: ${props.width};
        `
    }
    .rtl & {
        margin-right: 0;
        margin-left: 10px;
    }
    @media (max-width: 768px) {
        width: 100%;
        margin-top: 10px;
        text-align: center;
    }
`;

const StyledDropdown = styled(Dropdown)`
    &:not(.rs-dropdown-menu) {
        width: 100%;
        height: 36px;
    }
    
    &&&&& {
        .rs-btn {
            width: 100%;
            height: 36px;
            padding: 8px 20px 8px 12px;
        }

        .rs-btn:not(:disabled):not(.rs-btn-disabled) {
            background-color: var(--color-brand2);
            color: white;

            &:hover {
                background-color: #5f2bb3;
                color: white;
            }
            
        }

        .rtl & .rs-btn {
            padding: 8px 12px 8px 32px;
        }
        
        .rs-dropdown-menu {
            background-color: #fdfdfd !important;
        }
        
        & > .rs-dropdown-item > .rs-dropdown-item-content:hover {
            background-color: #cfcfcf !important;
            color: #5c5c5c !important;
        }
        
        @media (max-width: 768px) {
            width: 140px;
        }
    }
`;
const StyledLoader = styled(Loader)`
  & span.rs-loader-spin {
    margin-top: 3px;
    margin-right: 5px;
  }
`;
